import React from 'react';
import PropTypes from 'prop-types';
import useCaptureMedia from '../../hooks/useCaptureMedia';
import CaptureMediaGrid from './CaptureMediaGrid';

export default function TaskCaptureMediaSection({ taskId }) {
  const { items, loading, error, fetchDownloadUrl, openCapture } = useCaptureMedia({
    taskId,
    enabled: Boolean(taskId),
  });

  if (!loading && !error && items.length === 0) {
    return null;
  }

  return (
    <div className="border rounded p-4 mb-4">
      <h6 className="fw-semibold mb-2">Field photos</h6>
      <p className="text-muted small mb-3">
        Images captured during this task. Click a thumbnail to view the full photo.
      </p>
      <CaptureMediaGrid
        items={items}
        loading={loading}
        error={error}
        fetchDownloadUrl={fetchDownloadUrl}
        onOpen={openCapture}
      />
    </div>
  );
}

TaskCaptureMediaSection.propTypes = {
  taskId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
